/**
 * Wrap an HTMLElement around each element in an HTMLElement array.
 * Simulates jQuery's $.wrap() function
 *
 * Usage:
 * var div = document.createElement('div');
 * div.wrap(message);
 */
HTMLElement.prototype.wrap = function(elms) {
  // Convert `elms` to an array, if necessary.
  if (!elms.length) {
    elms = [elms];
  }

  // Loops backwards to prevent having to clone the wrapper on the
  // first element (see `child` below).
  for (var i = elms.length - 1; i >= 0; i--) {
      var child = (i > 0) ? this.cloneNode(true) : this;
      var el    = elms[i];

      // Cache the current parent and sibling.
      var parent  = el.parentNode;
      var sibling = el.nextSibling;

      // Wrap the element (is automatically removed from its current
      // parent).
      child.appendChild(el);

      // If the element had a sibling, insert the wrapper before
      // the sibling to maintain the HTML structure; otherwise, just
      // append it to the parent.
      if (sibling) {
          parent.insertBefore(child, sibling);
      } else {
          parent.appendChild(child);
      }
  }
};

/**
 * Wrap an HTMLElement around another HTMLElement or an array of them.
 * Simulates jQuery's $.wrap() function
 *
 * Usage:
 * var fruits = document.getElementsByTagName('li');
 * var ol = document.createElement('ol');
 * wrapAll(fruits, ol);
 */
function wrapAll(nodes, wrapper) {
  // Cache the current parent and previous sibling of the first node.
  var parent = nodes[0].parentNode;
  var previousSibling = nodes[0].previousSibling;

  // Place each node in wrapper.
  //  - If nodes is an array, we must increment the index we grab from
  //    after each loop.
  //  - If nodes is a NodeList, each node is automatically removed from
  //    the NodeList when it is removed from its parent with appendChild.
  for (var i = 0; nodes.length - i; wrapper.firstChild === nodes[0] && i++) {
      wrapper.appendChild(nodes[i]);
  }

  // Place the wrapper just after the cached previousSibling,
  // or if that is null, just before the first child.
  var nextSibling = previousSibling ? previousSibling.nextSibling : parent.firstChild;
  parent.insertBefore(wrapper, nextSibling);

  return wrapper;
}
